// chips.
import { $$ } from './core.ts';

export function initChips(): void {
  // a chip group that drives a hidden input (filters): one value at a time
  $$('[data-ds-chips]').forEach(g => {
    const target = document.getElementById(g.dataset.dsChips!) as HTMLInputElement | null;
    g.addEventListener('click', e => {
      const c = (e.target as Element).closest<HTMLElement>('.ds-chip');
      if (!c || c.tagName === 'A') return;
      $$('.ds-chip', g).forEach(x => x.setAttribute('aria-pressed', String(x === c)));
      if (target) {
        target.value = c.dataset.value ?? '';
        target.form?.requestSubmit();
      }
    });
  });
}
